import React, { Component } from 'react';
import { Container } from './MoveTemplate.style';
import { Button, Div } from './MoveTemplate.style';
import { connect } from 'react-redux';

class MoveTemplate extends Component {
    render() {
        const { text, lang, onMoveOriginalTemplate } = this.props
        return (
            <Container>
                <Div height={"25px"} onClick={onMoveOriginalTemplate} background={"#eeeeee"} padding={"15px 0"}>
                    <Button>{text}</Button>
                </Div>
            </Container>
        );
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default connect(
    mapStateToProps,
    null
)(MoveTemplate)